import React from 'react';
import { AboutZev } from '../components/AboutZev';
import { EventAnnouncement } from '../components/EventAnnouncement';
import { Facilities } from '../components/Facilities';
import { FinalCTA } from '../components/FinalCTA';
import { Gallery } from '../components/Gallery';
import { Hero } from '../components/Hero';
import { Location } from '../components/Location';
import { PathwayCards } from '../components/PathwayCards';
export function HomePage() {
  return <>
      <Hero data-id="element-704" data-mp="2s1fpekhhy9k8" />
      <EventAnnouncement data-id="element-705" data-mp="2s1o48hx6joy2" />
      <PathwayCards data-id="element-706" data-mp="2s2h2eui2p64l" />
      <Gallery data-id="element-707" data-mp="2s2z78fiswso4" />
      <Facilities data-id="element-708" data-mp="2rzbcxe5j828c" />
      <AboutZev data-id="element-709" data-mp="36qbvwd3wneiq" />
      <Location data-id="element-710" data-mp="36qu1i0cgj53b" />
      <FinalCTA data-id="element-711" data-mp="36rdhvcmgllf8" />
    </>;
}